import $ from 'domtastic'




/* BROWSER
----------------------------------------------------------------------------------------------------*/

export default class Browser {

    constructor() {
        this.supports = {}

        const P  = navigator.platform
        const UA = navigator.userAgent
        const AV = navigator.appVersion


        // UA Sniffing
        this.isMobile  = (/iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(UA))
        this.isDesktop = !this.isMobile

        this.isChrome    = UA.indexOf('Chrome') > -1
        this.isExplorer  = UA.indexOf('MSIE') > -1
        this.isIE10      = AV.indexOf('MSIE 10') > -1
        this.isEdge      = /(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:|\bEdge\/)(\d+)/.test(UA)
        this.isFirefox   = UA.indexOf('Firefox') > -1
        this.isSafari    = UA.indexOf('Safari') > -1
        this.isOpera     = UA.indexOf('Presto') > -1 || UA.indexOf('OPR/') > -1
        this.isAndroid   = UA.toLowerCase().indexOf('android') > -1
        this.isiOS       = UA.match(/(iPad|iPhone|iPod)/g)
        this.isWindows   = P.indexOf('Win') > -1
        this.isWindows10 = UA.indexOf('Windows NT 10.0') > -1


        // IE + Edge voodoo
        if (this.isEdge && UA.indexOf('Trident/') > -1) {
            this.isEdge = false
            this.isIE11 = true
        }

        if (this.isExplorer && !this.isIE10) {
            this.isIE9 = true
            this.isIE11 = false
        }

        if (this.isIE9 || this.isIE10 || this.isIE11 || this.isEdge) {
            this.annoying = true
        }

        if (this.isE9 || this.isIE10 || this.isIE11) {
            this.isExplorer = true
        }

        if (this.isIE10) {
            this.isIE11 = false
        }

        if (this.isiOS) {
            const start = UA.indexOf('OS ')
            this.iOSVersion = window.Number(UA.substr(start + 3, 3).replace('_', '.'))
        }


        // Specificities
        if (this.isChrome && this.isSafari) { this.isSafari = false }
        if (this.isChrome && this.isEdge) { this.isChrome = false }
        this.isSafariDesktop = (!this.isMobile && this.isSafari)

        this.isiPad   = (/iPad/i.test(UA))
        this.isiPhone = (/iPhone|iPod/i.test(UA))
        this.isWebApp = window.navigator.standalone


        // Cookies
        this.cookiesHandler  = () => { this.onCookiesAccepted() }
        this.cookiesAccepted = $('.cookies-notice').length < 1


        this.bindEvents()
        this.addBrowserClass()
        this.detectFeatures()
    }


    bindEvents() {
        $(document).on('cookiesAccepted', this.cookiesHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onCookiesAccepted() {
        this.cookiesAccepted = true

        $(document).off('cookiesAccepted', this.cookiesHandler)
    }




    /* Actions
    --------------------------------------------------------- */

    addBrowserClass() {
        const $html = $('html')

        if (this.isWindows)  $html.addClass('windows')
        if (this.isMobile)   $html.addClass('mobile')
        if (this.isAndroid)  $html.addClass('android')

        if (this.isiOS) {
            $html.addClass('iOS')
            $html.addClass(`iOS${this.iOSVersion.toString().split('.')[0]}`)
        }

        if (this.isFirefox)  $html.addClass('firefox')
        if (this.isSafari)   $html.addClass('safari')
        if (this.isChrome)   $html.addClass('chrome')
        if (this.isExplorer) $html.addClass('ie')
        if (this.isEdge)     $html.addClass('edge')
        if (this.isIE9)      $html.addClass('ie9')
        if (this.isIE10)     $html.addClass('ie10')
        if (this.isIE11)     $html.addClass('ie11')

        if (this.isIE9 || this.isIE10 || this.isIE11) $html.addClass('ie')

        if (this.isWindows10) $html.addClass('w10')

        if (this.isWebApp)   $html.addClass('webapp')

        $html.removeClass('no-js')
    }


    detectFeatures() {
        let supportsPassive = false

        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: () => {
                    supportsPassive = true
                },
            })

            window.addEventListener('test', null, opts)
        } catch (e) {
            //
        }

        this.supports.passive = supportsPassive

        $('html').toggleClass('focus-within', isSelectorSupported('.yolo:focus-within'))
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const isSelectorSupported = (selector) => {
    const doc  = document
    const root = doc.documentElement
    const head = doc.head || root
    const style = doc.createElement('style')

    head.insertBefore(style, head.firstChild)
    const { sheet } = style

    try {
        sheet.insertRule(`${selector}{}`, 0)
        sheet.deleteRule(0)

        style.parentNode.removeChild(style)
        return true
    } catch (e) {
        style.parentNode.removeChild(style)
        return false
    }
}



